module.exports = __webpack_public_path__ + "img/ico_badge_new.60de7c54.svg";